import {
  type PillSearchScope,
  type PillSearchGroup,
} from "./pill-search-records";

import { useSiteSearch } from "./use-site-search";

import { useAccountSearch } from "./use-account-search";

export function usePillSearchGroups({
  query,
  ready,
  scope,
  member,
}: {
  query: string;
  ready: boolean;
  scope: PillSearchScope;
  member: boolean;
}) {
  const searching = query !== "";
  const site = useSiteSearch({
    query,
    ready,
    enabled: searching && scope !== "account",
    member,
  });
  const account = useAccountSearch({
    query,
    ready,
    enabled: searching && member && scope !== "site",
  });
  const groups: PillSearchGroup[] = [];

  if (searching && scope !== "account") groups.push(...site);

  if (searching && member && scope !== "site") groups.push(...account);

  return groups;
}
